<div class="svg-animation">
    <div>
        <img *ngIf="currentFrame === 0" src="assets/images/loading-animation/loading1.svg" alt="frame 1" />
        <img *ngIf="currentFrame === 1" src="assets/images/loading-animation/loading2.svg" alt="frame 2" />
        <img *ngIf="currentFrame === 2" src="assets/images/loading-animation/loading3.svg" alt="frame 3" />
        <img *ngIf="currentFrame === 3" src="assets/images/loading-animation/loading4.svg" alt="frame 4" />
        <img *ngIf="currentFrame === 4" src="assets/images/loading-animation/loading5.svg" alt="frame 5" />
        <img *ngIf="currentFrame === 5" src="assets/images/loading-animation/loading6.svg" alt="frame 6" />
    </div>
</div>
<div class="loading-text">
    <p class="titleMessage">
        {{ currentMessage === 0 ? 'Preparando seu plano' : currentMessage === 1 ? 'Mais um momento' : 'Estamos quase lá' }}
    </p>
    <p class="subMessage">
        {{ currentMessage === 0 ? 'Carregando seus dados para compra...' : currentMessage === 1 ? 'Configurando o produto selecionado...' : 'Deixando tudo pronto para sua compra...' }}
    </p>
</div>


